exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._1YmdBmcJKZfyxkmswdqgwC{margin-top:25px;height:34px}", ""]);

// exports
exports.locals = {
	"formControlNoLabel": "_1YmdBmcJKZfyxkmswdqgwC"
};